import React from 'react';
import styled, { css } from 'styled-components';

import { IconButton } from '@workboard/wobo-ui';
import SvgIcon from '@material-ui/core/SvgIcon';

import { useTranslation } from 'react-i18next';
import PinFilledIcon from '../../../../vectors/pin-filled.svg';
import PinFilledStarIcon from '../../../../vectors/pin-filled-star.svg';

interface IIcon {
  $width?: number;
}

const PinButton = styled(IconButton)<IIcon>`
  ${({ $width }) =>
    $width &&
    css`
      width: ${$width}px;
      height: ${$width}px;
    `}
  ${({ $isFav }) =>
    $isFav
      ? css`
          opacity: 1;

          svg {
            g {
              fill: rgb(0, 114, 171);
            }
          }
        `
      : css`
          opacity: 0;
        `}
  transition-property: background-color, color, opacity, visibility;
  transition-duration: 0.2s;
  transition-timing-function: ease-in-out;
  background: inherit;

  span {
    height: 24px;
  }

  &:hover,
  &:focus-within,
  &:focus {
    background: #ebeef2;
  }
`;

const FavoritePin = (props): JSX.Element => {
  const { t } = useTranslation();
  const { onClickPin, isFavorite, width, id } = props;
  return (
    <PinButton
      onClick={onClickPin}
      title={isFavorite ? t('Remove from Favorites') : t('Add to Favorites')}
      $width={width}
      $isFav={isFavorite}
      id={id}
      compact
    >
      <SvgIcon>
        {isFavorite ? <PinFilledStarIcon /> : <PinFilledIcon />}
      </SvgIcon>
    </PinButton>
  );
};

export default FavoritePin;
